import { css } from 'emotion';

import { colors } from '@cobliteam/base-components/src/styles/colors';

export const DRAWER_WIDTH = 600;

export const checklistDrawerTitle = css`
  min-width: 0;
`;

export const editIcon = css`
  color: ${colors.gray.default};
  height: 12px;
  width: 12px;

  &:hover {
    color: ${colors.gray.dark};
  }
`;

export const editableLabel = css`
  border-radius: 3px;
  margin-right: 20px;
`;
